import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";

import { signInController } from "../controllers/signInController";

import * as core from "../redux/modules/core";
import * as signIn from "../redux/modules/signIn";

const queryString = require("query-string");

class SignIn extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    inputForm: PropTypes.object.isRequired,
    error: PropTypes.bool.isRequired,
    isFetching: PropTypes.bool.isRequired,
    redirectToHome: PropTypes.bool.isRequired,
  };

  componentDidMount() {
    this.props.dispatch(core.actions.arrivedSignIn());
  }

  componentWillUnmount() {
    this.props.dispatch(core.actions.leftSignIn());
  }

  onSubmit = (e) => {
    e.preventDefault();

    const { id, password } = this.props.inputForm;
    if (!id || !password) {
      alert("IDとパスワードを入力してください");
      return false;
    }
    this.props.dispatch(
      signInController.signIn(
        this.props.inputForm.id,
        this.props.inputForm.password
      )
    );
  };

  render() {
    const queries = queryString.parse(this.props.location.search);

    if (this.props.redirectToHome) {
      return <Redirect to="/" />;
    } else {
      return (
        <div className="ui-full-height-body">
          <form onSubmit={this.onSubmit} className="ui-sign-in-form">
            <h1 className="text-center h3 font-weight-normal">
              ポイント付与アプリ
            </h1>
            {queries.unauthorized ? (
              <div className="alert alert-primary" role="alert">
                認証の期限が切れましたので、再度ログインしてください。
              </div>
            ) : (
              ""
            )}
            {this.props.error ? (
              <div className="alert alert-danger" role="alert">
                ログインID、もしくはパスワードが正しくありません。もう一度入力してください。
              </div>
            ) : (
              ""
            )}
            <input
              type="text"
              className="form-control mt-3"
              placeholder="ID"
              value={this.props.inputForm.id || ""}
              onChange={(e) => {
                this.props.dispatch(
                  signIn.actions.inputForm({
                    formId: "id",
                    value: e.target.value,
                  })
                );
              }}
            />
            <input
              type="password"
              className="form-control mb-3"
              placeholder="Password"
              value={this.props.inputForm.password || ""}
              onChange={(e) => {
                this.props.dispatch(
                  signIn.actions.inputForm({
                    formId: "password",
                    value: e.target.value,
                  })
                );
              }}
            />

            <button type="submit" className="btn btn-primary btn-block">
              ログイン
            </button>
          </form>
        </div>
      );
    }
  }
}

export default connect((state) => {
  const signIn = state.signIn || {};
  const screenSignIn = signIn.screenSignIn || {};

  return {
    inputForm: { ...screenSignIn },
    error: !!screenSignIn.error,
    isFetching: !!screenSignIn.isFetching,
    redirectToHome: !!screenSignIn.succeededSignInApi,
  };
})(SignIn);
